module.exports = __webpack_public_path__ + "img/img_list_4@2x.0dd2e79b.png";